import { Product2x1 } from "../modules/product2x1";

export const Product2x1Page = () => {
  return <Product2x1 />;
};
